import * as Types from '../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type UngroupMutationVariables = Types.Exact<{
  input: Types.UngroupCommand;
}>;


export type UngroupMutation = { __typename?: 'MutationModel', projectRequests: { __typename?: 'ProjectRequestMutationModel', ungroup: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const UngroupDocument = gql`
    mutation Ungroup($input: UngroupCommand!) {
  projectRequests {
    ungroup(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type UngroupMutationFn = Apollo.MutationFunction<UngroupMutation, UngroupMutationVariables>;

/**
 * __useUngroupMutation__
 *
 * To run a mutation, you first call `useUngroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUngroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ungroupMutation, { data, loading, error }] = useUngroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUngroupMutation(baseOptions?: Apollo.MutationHookOptions<UngroupMutation, UngroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UngroupMutation, UngroupMutationVariables>(UngroupDocument, options);
      }
export type UngroupMutationHookResult = ReturnType<typeof useUngroupMutation>;
export type UngroupMutationResult = Apollo.MutationResult<UngroupMutation>;
export type UngroupMutationOptions = Apollo.BaseMutationOptions<UngroupMutation, UngroupMutationVariables>;